import React from "react";
import translate from "../../../../../translate";
import API from "../../../../../api/api";
import {LoadingScreen} from "../../../loadingScreen";
import IncomingAttack from "./row";
import IncomingAttackListHeader from "./header";
import WorldDataLoader from "../../worldDataLoader";
import {WorldDataTypes} from "../../../../../travian/worldData";
import {Button, ButtonTypes} from "../../../ui/spectre/buttons";
import {useRevalidator} from "react-router-dom";
import {Icon} from "../../../ui/spectre/icon";
import {RichTableContainer, useRichTableContext} from "../../../tableUtils/richTableContainer";

function IncomingAttackListTable({ groupId = null }) {
    const {data, setData, isFiltered} = useRichTableContext();

    if(data === null) {
        return <LoadingScreen />
    }

    if(data.length === 0 && !isFiltered) {
        return <div className={'bg-info'}>
            {translate('tool/trav/22/noIncomingSaved')}
        </div>
    }

    async function update(id, newParameters) {
        const newRow = await API.post(
            'userData/Travian/IncomingAttacks/updateComment',
            { id, "new": newParameters, groupId: groupId }
        );
        const newData = [...data];
        const index = newData.findIndex(datum => datum.id === id);
        if(index !== -1) {
            newData[index] = newRow;
            setData(newData);
        }
    }

    return <>
        <IncomingAttackListHeader />
        {
            data.length === 0
                ? <div className={'text-center full-width'}>{translate('general/tables/filtered_no_data')}</div>
                : data.map(datum =>
                    <IncomingAttack
                        key={datum.id}
                        data={datum}
                        onChange={(params, id) => update(id, params)}
                        groupId={groupId}
                    />
                )
        }
    </>
}

export default function IncomingAttackList({ data = null, groupId = null }) {
    const revalidator = useRevalidator();
    return <WorldDataLoader types={[WorldDataTypes.Village, WorldDataTypes.Player]}>
        <div className={'mb-2'}>
            <Button buttonTypes={[ButtonTypes.primary]} onClick={() => revalidator.state === 'idle' && revalidator.revalidate()}>
                <div className={'d-inline-block mr-2'}>
                    <Icon type={revalidator.state === 'idle' ? 'refresh' : 'refresh icon-animate-spin'} />
                </div>
                {translate('tool/trav/22/reload_incoming')}
            </Button>
        </div>
        <RichTableContainer initialData={data}>
            <IncomingAttackListTable groupId={groupId} />
        </RichTableContainer>
    </WorldDataLoader>
}
